<template>
  <div class="addProject">
    <el-form
      class="projectForm"
      :rules="projectFormRules"
      ref="projectForm"
      :model="projectForm"
      label-width="100px"
    >
      <div class="row">
        <div class="base-info">
          <p>基本信息</p>
          <div class="token" v-if="isFlag === 3">
            <span>水晶Token：{{tokenText}}</span>
            <img class="copy" src="../../../../../assets/images/copy.png" @click="copyText">
          </div>
        </div>
        <div class="row-item">
          <el-form-item label="客户名称" prop="customerId">
            <el-select
              filterable
              class="white w294"
              v-model="projectForm.customerId"
              :disabled="isFlag === 3"
              placeholder="请选择客户"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input
              v-model="projectForm.projectName"
              :disabled="isFlag === 3"
              class="white w294"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select
              class="white w294"
              v-model="projectForm.head"
              :disabled="isFlag === 3"
              placeholder="请选择负责人"
            >
              <el-option
                v-for="item in headList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同时间" prop="date">
            <el-date-picker
              class="w294"
              v-model="projectForm.date"
              :disabled="isFlag === 3"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="数据来源" prop="dataSource">
            <el-select
              class="white w294"
              v-model="projectForm.dataSource"
              :disabled="isFlag === 3"
              placeholder="请选择数据来源"
            >
              <el-option
                v-for="item in dataSourceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税率" prop="taxRate">
            <el-input
              @input="taxRateInput"
              v-model="projectForm.taxRate"
              :disabled="isFlag === 3"
              class="white w294"
              placeholder="示例：税率6%，填写0.06"
            ></el-input>
          </el-form-item>
          <el-form-item label="实占面积" prop="useArea">
            <el-input
              @input="useAreaInput"
              v-model="projectForm.useArea"
              :disabled="isFlag === 3"
              class="white w294"
              placeholder="请输入实占面积"
            ></el-input>
          </el-form-item>
          <el-form-item label="分摊面积" prop="shareArea">
            <el-input
              @input="shareAreaInput"
              :disabled="isFlag === 3"
              v-model="projectForm.shareArea"
              class="white w294"
              placeholder="请输入分摊面积"
            ></el-input>
          </el-form-item>
          <el-form-item label="保底费" prop="minimumFee">
            <el-input
              @input="minimumFeeInput"
              :disabled="isFlag === 3"
              v-model="projectForm.minimumFee"
              class="white w294"
              placeholder="请输入费用"
            ></el-input>
          </el-form-item>
          <el-form-item label="截单时间" prop="finalOrderTime" class="cut-time">
            <el-time-picker
              class="white w294"
              v-model="projectForm.finalOrderTime"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              :disabled="isFlag === 3"
              placeholder="请选择截单时间">
            </el-time-picker>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <p class="label2">场租计费规则</p>
        <div class="row-item">
          <el-form-item label="仓库" prop="warehouseId">
            <el-select
              class="white w294"
              :disabled="isFlag === 3"
              v-model="projectForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="合同面积" prop="contractArea">
             <el-input
               @input="contractAreaInput"
               :disabled="isFlag === 3"
               v-model="projectForm.contractArea"
               class="white w294"
               placeholder="请输入合同面积"
             ></el-input>
           </el-form-item>
           <el-form-item label="约定坪数" prop="area">
             <el-input
               @input="areaInput"
               v-model="projectForm.area"
               class="white w230"
               :placeholder="
                 !projectForm.areaStatus ? '无需输入' : '请输入约定坪数'
               "
               :disabled="isFlag === 3?true:!projectForm.areaStatus"
             >
             </el-input>
             <el-select
               class="white w64"
               :disabled="isFlag === 3"
               v-model="projectForm.areaStatus"
              @change="changeAreaStatus"
             >
               <el-option
                 v-for="item in disabledList"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id"
               ></el-option>
             </el-select>
           </el-form-item>
           <el-form-item
             label="坪数规则"
             prop="areaUtilizationType"
             v-show="projectForm.areaStatus"
           >
             <el-select
               class="white w294"
               v-model="projectForm.areaUtilizationType"
               :disabled="isFlag === 3"
               placeholder="请选择坪数规则"
             >
               <el-option
                 v-for="item in areaUtilization"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id"
               ></el-option>
             </el-select>
           </el-form-item>
           <el-form-item label="场租月单价" prop="rentPriceMonth">
             <el-input
               @input="rentPriceMonthInput"
               v-model="projectForm.rentPriceMonth"
               :disabled="isFlag === 3"
               class="white w294"
               placeholder="请输入场租月单价"
             >
               <span slot="suffix">元/月</span>
             </el-input>
           </el-form-item>
           <el-form-item label="场租月保底" prop="guaranteedRentPrice">
             <el-input
               @input="guaranteedRentPriceInput"
               v-model="projectForm.guaranteedRentPrice"
               class="white w230"
               :placeholder="
                 !projectForm.guaranteedRentPriceStatus
                   ? '无需输入'
                   : '场租月保底'
               "
               :disabled="isFlag === 3?true:!projectForm.guaranteedRentPriceStatus"
             >
               <span slot="suffix" v-show="projectForm.guaranteedRentPriceStatus"
                 >元/月</span
               >
             </el-input>
             <el-select
               class="white w64"
               :disabled="isFlag === 3"
               v-model="projectForm.guaranteedRentPriceStatus"
             >
               <el-option
                 v-for="item in disabledList"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id"
               ></el-option>
             </el-select>
           </el-form-item>
        </div>
      </div>
      <div class="row">
        <p class="label2">操作收入计费规则</p>
        <div class="row-item">
          <el-form-item label="起步价格" prop="startPrice">
            <el-input
              @input="startPriceInput"
              v-model="projectForm.startPrice"
              :disabled="isFlag === 3"
              class="white w294"
              placeholder="请输入起步价格"
            >
              <span slot="suffix">元/单</span>
            </el-input>
          </el-form-item>
          <el-form-item label="件数范围" prop="number">
            <el-input
              @input="numberInput"
              v-model="projectForm.number"
              class="white w230"
              :placeholder="
                !projectForm.numberStatus ? '无需输入' : '请输入件数范围'
              "
              :disabled="isFlag === 3?true:!projectForm.numberStatus"
            ></el-input>
            <el-select
              class="white w64"
              :disabled="isFlag === 3"
              v-model="projectForm.numberStatus"
              @change="changeNumberStatus"
            >
              <el-option
                v-for="item in disabledList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="额外费用" prop="additionalCosts">
              <el-input
                @input="additionalCostsInput"
                v-model="projectForm.additionalCosts"
                class="white w294"
                :disabled="isFlag === 3||!projectForm.numberStatus ? true:false"
                placeholder="请输入额外费用"
              >
                <span slot="suffix">元/件</span>
              </el-input>
            </el-form-item>
            <el-form-item label="操作月保底" prop="guaranteedOperatePrice">
              <el-input
                @input="guaranteedOperatePriceInput"
                v-model="projectForm.guaranteedOperatePrice"
                class="white w230"
                :placeholder="
                  !projectForm.guaranteedOperatePriceStatus
                    ? '无需输入'
                    : '操作月保底'
                "
                :disabled="isFlag === 3?true:!projectForm.guaranteedOperatePriceStatus"
              >
                <span
                  slot="suffix"
                  v-show="projectForm.guaranteedOperatePriceStatus"
                  >元/月</span
                >
              </el-input>
              <el-select
                class="white w64"
                :disabled="isFlag === 3"
                v-model="projectForm.guaranteedOperatePriceStatus"
              >
                <el-option
                  v-for="item in disabledList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="borderTop">
          <div class="row-item">
            <el-form-item label="退货起步价格" prop="returnStartingPrice">
              <el-input
                @input="returnStartingPriceInput"
                :disabled="isFlag === 3"
                v-model="projectForm.returnStartingPrice"
                class="white w294"
                placeholder="请输入价格"
              >
                <span slot="suffix">元/单</span>
              </el-input>
            </el-form-item>
            <el-form-item label="退货件数范围" prop="rangeOfReturnedItems">
              <el-input
                @input="rangeOfReturnedItemsInput"
                v-model="projectForm.rangeOfReturnedItems"
                class="white w230"
                :placeholder="
                  !projectForm.rangeOfReturnedItemsStatus
                    ? '无需输入'
                    : '请输入范围'
                "
                :disabled="isFlag === 3?true:!projectForm.rangeOfReturnedItemsStatus"
              ></el-input>
              <el-select
                class="white w64"
                :disabled="isFlag === 3"
                v-model="projectForm.rangeOfReturnedItemsStatus"
                @change="changeRangeOfReturnedItemsStatus"
              >
                <el-option
                  v-for="item in disabledList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="超件退货价格" prop="returnPriceOfSuperParts">
              <el-input
                @input="returnPriceOfSuperPartsInput"
                v-model="projectForm.returnPriceOfSuperParts"
                class="white w294"
                :disabled="isFlag === 3||!projectForm.rangeOfReturnedItemsStatus ? true:false"
                placeholder="请输入费用"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="borderTop">
          <div class="row-item">
            <el-form-item label="大宗出库价格" prop="bulkDeliveryPrice">
              <el-input
                @input="bulkDeliveryPriceInput"
                :disabled="isFlag === 3"
                v-model="projectForm.bulkDeliveryPrice"
                class="white w294"
                placeholder="请输入费用"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="borderTop">
          <div class="row-item">
            <el-form-item label="卸货价格" prop="unloadingPrice">
              <el-input
                @input="unloadingPriceInput"
                :disabled="isFlag === 3"
                v-model="projectForm.unloadingPrice"
                class="white w294"
                placeholder="请输入费用"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="borderTop">
          <div class="increment-service">
            <div class="increment-service-title">增值服务</div>
            <div class="row-item"
              v-for="(domain, index) in projectForm.domains"
              :key="index"
            >
              <el-form-item
                class="service-name"
                label="服务名称"
                :prop="'domains.' + index + '.serviceType'"
                :rules="{
                  required: true, message: '服务名称不能为空', trigger: 'blur'
                }"
              >
                <span class="sort">{{index+1}}</span>
                <el-select
                  class="white w294"
                  v-model="domain.serviceType"
                  :disabled="isFlag === 3"
                  placeholder="请选择服务名称"
                  @change="changeServiceName(index)"
                >
                  <el-option
                    v-for="item in serviceNameList"
                    :key="item.id"
                    :label="item.serviceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="单价（元）"
                :prop="'domains.' + index + '.unitPrice'"
                :rules="{
                  required: true, message: '单价不能为空', trigger: 'blur'
                }"
              >
                <el-input
                  @input="unitPriceInput(index)"
                  :disabled="isFlag === 3"
                  v-model="domain.unitPrice"
                  class="white w294"
                  placeholder="请输入金额"
                ></el-input>
                <el-button v-if="index>0 && isFlag !== 3" type="text" class="btn-text remove-domain" @click.prevent="removeDomain(domain)">删除</el-button>
              </el-form-item>
            </div>
          </div>
          <div>
            <el-button 
              type="text" 
              class="btn-text"
              v-if="isFlag !== 3"
              @click="addDomain"
            >+添加服务</el-button>
          </div>
        </div>
      </div>
      <div class="row">
        <p class="label2">物流计费规则</p>
        <div class="row-item">
          <el-form-item label="市配单价" prop="cityMatchingPrice">
            <el-input
              @input="cityMatchingPriceInput"
              :disabled="isFlag === 3"
              v-model="projectForm.cityMatchingPrice"
              class="white w294"
              placeholder="请输入市配单价"
            ></el-input>
          </el-form-item>
        </div>

        <div class="borderTop">
          <div class="row-item">
            <el-form-item label="适用范围" prop="applicationScope">
              <el-select
                class="white w294"
                :disabled="isFlag === 3"
                v-model="projectForm.applicationScope"
                placeholder="请选择适用范围"
              >
                <el-option
                  v-for="item in expressTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="面单费用" prop="faceFee" v-if="projectForm.applicationScope">
              <el-input
                class="white w294"
                :disabled="isFlag === 3"
                placeholder="请输入价格"
                v-model="projectForm.faceFee"
                @input="faceFeeInput"
              >
                <span slot="suffix">元/单</span>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="footer">
          <el-button class="btn-white" @click="closeDialog">
            {{ isFlag !== 3?'取消':'返回' }}
          </el-button>
          <el-button
            v-if="isFlag !== 3"
            class="btn-blue"
            @click="addProject('projectForm')"
            >保存</el-button
          >
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getDecimal, getInteger, formatTimeToDate } from "common/js/util";
import Logistics from "models/logistics";
const logistics = new Logistics();
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  data() {
    return {
      isFlag: null,
      customerList: [] /* 客户名称列表 */,
      headList: [] /* 负责人列表 */,
      warehouseList: [],
      expressTypeList: [],      /* 使用范围列表 */
      dataSourceList: [
        /* 数据来源列表 */
        {
          id: 1,
          name: "WMS",
        },
        {
          id: 2,
          name: "易仓储",
        },
      ],
      areaUtilization: [
        /* 坪数规则列表 */
        {
          id: 1,
          name: "差额收费",
        },
        {
          id: 2,
          name: "全额收费",
        },
      ],
      disabledList: [
        { name: "无", id: false },
        { name: "有", id: true },
      ],
      serviceNameList: [],
      projectForm: {
        id: "",
        warehouseId: "",
        customerId: "",
        projectName: "",
        dataSource: "",
        taxRate: "",
        useArea: "",
        shareArea: "",
        cityMatchingPrice: "",
        guaranteedOperatePrice: "",
        guaranteedOperatePriceStatus: false,
        head: "",
        date: "",
        number: "",
        numberStatus: false,
        startPrice: "",
        additionalCosts: "",
        returnStartingPrice: "",
        rangeOfReturnedItems: "",
        rangeOfReturnedItemsStatus: false,
        returnPriceOfSuperParts: "",
        bulkDeliveryPrice: "",
        unloadingPrice: "",
        applicationScope: "",
        faceFee: "",
        contractArea: '',
        area: "",
        areaStatus: false,
        areaUtilizationType: "",
        rentPriceMonth: "",
        guaranteedRentPrice: "",
        guaranteedRentPriceStatus: false,
        minimumFee: '',
        finalOrderTime: '',
        domains: [{
          serviceType: null,
          serviceName: '',
          unitPrice: null
        }]
      },
      projectFormRules: {
        warehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        customerId: [
          { required: true, message: "请选择客户", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        dataSource: [
          { required: true, message: "请选择数据来源", trigger: "change" },
        ],
        taxRate: [{ required: true, message: "请输入税率", trigger: "blur" }],
        useArea: [
          { required: true, message: "请输入实占面积", trigger: "blur" },
        ],
        shareArea: [
          { required: true, message: "请输入分摊面积", trigger: "blur" },
        ],
        // cityMatchingPrice: [
        //   { required: true, message: "请输入市配单价", trigger: "blur" },
        // ],
        head: [{ required: true, message: "请选择负责人", trigger: "change" }],
        startPrice: [
          { required: true, message: "请输入起步价", trigger: "blur" },
        ],
        returnStartingPrice: [
          { required: true, message: "请输入退货起步价格", trigger: "blur" },
        ],
        bulkDeliveryPrice: [
          { required: true, message: "请输入大宗出库价格", trigger: "blur" },
        ],
        unloadingPrice: [
          { required: true, message: "请输入卸货价格", trigger: "blur" },
        ],
        applicationScope: [
          { required: true, message: "请选择适用范围", trigger: "change" },
        ],
      },
      tokenText: ''
    };
  },

  created() {
    this.isFlag = Number(this.$route.query.isFlag);
    let projectId = Number(this.$route.query.projectId);
    this.getHeadList();
    this.getWarehouse();
    this.getCustomerList();
    this.initGetExpressTypeList()
    this.initServiceNameList()
    if (projectId) {
      this.projectDetail(projectId);
    }
  },

  methods: {
    /* 获取快递列表 */
    initGetExpressTypeList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.expressTypeList = arr;
        }
      });
    },
    /* 获取客户列表 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    /* 获取服务名称列表 */
    initServiceNameList() {
      projectManage.getServiceNameList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.serviceName = value.serviceName;
            arr.push(obj);
          });
          this.serviceNameList = arr;
        }
      });
    },
    /* 获取负责人列表 */
    getHeadList() {
      projectManage.getEmployeeList().then((res) => {
        let headList = [];
        res.result.map((value) => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.name;
          headList.push(obj);
        });
        this.headList = headList;
      });
    },
    /* 获取仓库数据 */
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    closeDialog() {
      this.$router.go(-1);
    },
    /* 新增、编辑项目 */
    addProject(formName) {
      if (!this.projectForm.guaranteedRentPriceStatus) {
        this.projectForm.guaranteedRentPrice = "";
      } else {
        if (this.projectForm.guaranteedRentPrice === "") {
          this.$message.error("请输入场租月保底");
          return false;
        }
      }
      if (!this.projectForm.areaStatus) {
        this.projectForm.area = "";
      } else {
        if (this.projectForm.area === "") {
          this.$message.error("请输入坪数");
          return false;
        } else if (this.projectForm.areaUtilizationType === "") {
          this.$message.error("请选择坪数规则");
          return false;
        }
      }
      if (!this.projectForm.guaranteedOperatePriceStatus) {
        this.projectForm.guaranteedOperatePrice = "";
      } else {
        if (this.projectForm.guaranteedOperatePrice === "") {
          this.$message.error("请输入操作月保底");
          return false;
        }
      }
      if (!this.projectForm.numberStatus) {
        this.projectForm.number = "";
      } else {
        if (this.projectForm.number === "") {
          this.$message.error("请输入件数范围");
          return false;
        }
        if (this.projectForm.additionalCosts === "") {
          this.$message.error("请输入额外费用");
          return false;
        }
      }
      if (!this.projectForm.rangeOfReturnedItemsStatus) {
        this.projectForm.rangeOfReturnedItems = "";
      } else {
        if (this.projectForm.rangeOfReturnedItems === "") {
          this.$message.error("请输入退货件数范围");
          return false;
        }
        if (this.projectForm.returnPriceOfSuperParts === "") {
          this.$message.error("请输入超件退货价格");
          return false;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {};
          data.projectsName = this.projectForm.projectName;
          data.warehouseId = this.projectForm.warehouseId;
          data.customerId = this.projectForm.customerId;
          data.businessOwner1 = this.projectForm.head;
          data.contractBeginTime = this.projectForm.date[0];
          data.contractEndTime = this.projectForm.date[1];
          data.dataSource = this.projectForm.dataSource;
          data.taxRate = this.projectForm.taxRate;
          data.useArea = this.projectForm.useArea;
          data.shareArea = this.projectForm.shareArea;
          data.cityMatchingPrice = this.projectForm.cityMatchingPrice === "" ? 0 :Number(this.projectForm.cityMatchingPrice);
          data.bulkUnitPrice = this.projectForm.bulkDeliveryPrice;
          data.unloadUnitPrice = this.projectForm.unloadingPrice;
          data.returnCharge = {};
          data.returnCharge.unitPrice = this.projectForm.returnStartingPrice;
          data.returnCharge.quantityLimit = this.projectForm.rangeOfReturnedItems === "" ? 0 : Number(this.projectForm.rangeOfReturnedItems);
          data.returnCharge.excessUnitPrice = this.projectForm.returnPriceOfSuperParts === "" ? 0 : Number(this.projectForm.returnPriceOfSuperParts);
          data.operatorCharge = {};
          data.operatorCharge.unitPrice = this.projectForm.startPrice;
          data.operatorCharge.quantityLimit =
            this.projectForm.number === "" ? 0 : Number(this.projectForm.number);
          data.operatorCharge.excessUnitPrice = this.projectForm.additionalCosts === "" ? 0 : Number(this.projectForm.additionalCosts);
          data.guaranteedOperatePrice =
            this.projectForm.guaranteedOperatePrice === ""
              ? 0
              : this.projectForm.guaranteedOperatePrice;
          data.rentChargeType = 1
          data.applicationScope = this.projectForm.applicationScope;
          data.faceFee = this.projectForm.faceFee?Number(this.projectForm.faceFee):0;
          data.rentChargeConfig = {};
          data.rentChargeConfig.areaUtilizationType = this.projectForm.areaUtilizationType === "" ? 0 : this.projectForm.areaUtilizationType;
          data.rentChargeConfig.contractArea = this.projectForm.contractArea == ''?0:this.projectForm.contractArea;
          data.rentChargeConfig.areaUtilization = this.projectForm.area === "" ? 0 : this.projectForm.area;
          data.rentChargeConfig.rentPriceMonth = this.projectForm.rentPriceMonth == '' ? 0 : this.projectForm.rentPriceMonth;
          data.rentChargeConfig.guaranteedRentPrice =
            this.projectForm.guaranteedRentPrice === ""
              ? 0
              : this.projectForm.guaranteedRentPrice;
          data.minimumFee = this.projectForm.minimumFee? Number(this.projectForm.minimumFee) : 0
          data.finalOrderTime = this.projectForm.finalOrderTime
          data.extraServiceList = this.projectForm.domains
          if (this.projectForm.id) {
            data.id = this.projectForm.id;
            projectManage.postUpdateProject(data).then((res) => {
              if (res.success) {
                this.$message.success("编辑成功");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            projectManage.postAddProject(data).then((res) => {
              if (res.success) {
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /* 获取详情数据 */
    projectDetail(id) {
      projectManage.getProjectDetail(id).then((res) => {
        if (res.success) {
          this.projectForm.id = res.result.id;
          this.tokenText = res.result.projectToken;
          this.projectForm.warehouseId = res.result.warehouseId;
          this.projectForm.customerId = res.result.customerId;
          this.projectForm.projectName = res.result.projectsName;
          this.projectForm.head = res.result.businessOwner1;
          this.projectForm.date = res.result.contractBeginTime
            ? [
                formatTimeToDate(res.result.contractBeginTime),
                formatTimeToDate(res.result.contractEndTime),
              ]
            : "";
          this.projectForm.number =
            Number(res.result.operatorCharge.quantityLimit) === 0 ? "" : Number(res.result.operatorCharge.quantityLimit);
          this.projectForm.numberStatus =
            Number(res.result.operatorCharge.quantityLimit) === 0 ? false : true;
          this.projectForm.startPrice = res.result.operatorCharge.unitPrice;
          this.projectForm.additionalCosts = Number(res.result.operatorCharge.excessUnitPrice) === 0 ? "" :Number(res.result.operatorCharge.excessUnitPrice);
          this.projectForm.dataSource = res.result.dataSource;
          this.projectForm.taxRate = res.result.taxRate;
          this.projectForm.useArea = res.result.useArea;
          this.projectForm.shareArea = res.result.shareArea;
          this.projectForm.minimumFee = res.result.minimumFee;
          this.projectForm.finalOrderTime = res.result.finalOrderTime;
          this.projectForm.cityMatchingPrice = res.result.cityMatchingPrice;
          this.projectForm.applicationScope = res.result.applicationScope == 0 ?'':res.result.applicationScope;
          this.projectForm.faceFee = res.result.faceFee;
          this.projectForm.bulkDeliveryPrice = res.result.bulkUnitPrice;
          this.projectForm.unloadingPrice = res.result.unloadUnitPrice;
          this.projectForm.returnStartingPrice = res.result.returnCharge?
            res.result.returnCharge.unitPrice:'';
          this.projectForm.rangeOfReturnedItems = res.result.returnCharge?
            (Number(res.result.returnCharge.quantityLimit) === 0 ? "" : res.result.returnCharge.quantityLimit):''
          this.projectForm.rangeOfReturnedItemsStatus = res.result.returnCharge?
            (Number(res.result.returnCharge.quantityLimit) === 0 ? false : true):false;
          this.projectForm.returnPriceOfSuperParts = res.result.returnCharge?
            (Number(res.result.returnCharge.excessUnitPrice) === 0 ? "" :Number(res.result.returnCharge.excessUnitPrice)):'';

          this.projectForm.guaranteedRentPrice =
            Number(res.result.rentChargeConfig.data.guaranteedRentPrice) === 0
              ? ""
              : Number(res.result.rentChargeConfig.data.guaranteedRentPrice);
          this.projectForm.guaranteedRentPriceStatus =
            Number(res.result.rentChargeConfig.data.guaranteedRentPrice) === 0 ? false : true;

          this.projectForm.area =
            Number(res.result.rentChargeConfig.data.areaUtilization) === 0 ? "" : Number(res.result.rentChargeConfig.data.areaUtilization);
          this.projectForm.areaUtilizationType =
            Number(res.result.rentChargeConfig.data.areaUtilizationType) === 0
              ? ""
              : Number(res.result.rentChargeConfig.data.areaUtilizationType);
          this.projectForm.areaStatus =
            Number(res.result.rentChargeConfig.data.areaUtilization) === 0 ? false : true;
          this.projectForm.rentPriceMonth = Number(res.result.rentChargeConfig.data.rentPriceMonth) === 0 ? '':res.result.rentChargeConfig.data.rentPriceMonth;
          this.projectForm.contractArea = Number(res.result.rentChargeConfig.data.contractArea) === 0?'':res.result.rentChargeConfig.data.contractArea;

          this.projectForm.domains = res.result.extraServiceList
          this.projectForm.guaranteedOperatePrice =
            res.result.guaranteedOperatePrice === 0
              ? ""
              : res.result.guaranteedOperatePrice;
          this.projectForm.guaranteedOperatePriceStatus =
            res.result.guaranteedOperatePrice === 0 ? false : true;
        }
      });
    },
    changeAreaStatus() {
      if (!this.projectForm.areaStatus) {
        this.projectForm.area = ''
        this.projectForm.areaUtilizationType = ''
      }
    },
    changeNumberStatus() {
      if (!this.projectForm.numberStatus) {
        this.projectForm.number = ''
        this.projectForm.additionalCosts = ''
      }
    },
    changeRangeOfReturnedItemsStatus() {
      if (!this.projectForm.rangeOfReturnedItemsStatus) {
        this.projectForm.rangeOfReturnedItems = ''
        this.projectForm.returnPriceOfSuperParts = ''
      }
    },
    /* 限制税率 */
    taxRateInput() {
      let taxRate = this.projectForm.taxRate;
      this.projectForm.taxRate = getDecimal(taxRate);
    },
    /* 实占面积 */
    useAreaInput() {
      let useArea = this.projectForm.useArea;
      this.projectForm.useArea = getDecimal(useArea);
    },
    /* 分摊面积 */
    shareAreaInput() {
      let shareArea = this.projectForm.shareArea;
      this.projectForm.shareArea = getDecimal(shareArea);
    },
    /* 保底费 */
    minimumFeeInput() {
      let minimumFee = this.projectForm.minimumFee
      this.projectForm.minimumFee = getDecimal(minimumFee);
    },
     /* 合同面积 */
     contractAreaInput() {
       let contractArea = this.projectForm.contractArea;
       this.projectForm.contractArea = getDecimal(contractArea);
     },
     /* 坪数限制 */
     areaInput() {
       let area = this.projectForm.area;
       this.projectForm.area = getDecimal(area);
     },
     /* 场租月单价限制 */
     rentPriceMonthInput() {
       let rentPriceMonth = this.projectForm.rentPriceMonth;
       this.projectForm.rentPriceMonth = getDecimal(rentPriceMonth);
     },
     /* 月场租保底限制 */
     guaranteedRentPriceInput() {
       let guaranteedRentPrice = this.projectForm.guaranteedRentPrice;
       this.projectForm.guaranteedRentPrice = getDecimal(guaranteedRentPrice);
     },
    /* 起步价限制 */
    startPriceInput() {
      let startPrice = this.projectForm.startPrice;
      this.projectForm.startPrice = getDecimal(startPrice);
    },
    /* 件数限制 */
    numberInput() {
      if (this.projectForm.number > 20) {
        this.projectForm.number = ''
        return this.$message.error('件数范围不能超过20')
      }
      let number = this.projectForm.number;
      this.projectForm.number = getInteger(number);
    },
    /* 操作月保底 */
    guaranteedOperatePriceInput() {
      let guaranteedOperatePrice = this.projectForm.guaranteedOperatePrice;
      this.projectForm.guaranteedOperatePrice = getDecimal(
        guaranteedOperatePrice
      );
    },
    /* 额外费用限制 */
    additionalCostsInput() {
      let additionalCosts = this.projectForm.additionalCosts;
      this.projectForm.additionalCosts = getDecimal(additionalCosts);
    },
    /* 退货起步价格限制 */
    returnStartingPriceInput() {
      let returnStartingPrice = this.projectForm.returnStartingPrice;
      this.projectForm.returnStartingPrice = getDecimal(returnStartingPrice);
    },
    /* 退货件数范围限制 */
    rangeOfReturnedItemsInput() {
      let rangeOfReturnedItems = this.projectForm.rangeOfReturnedItems;
      this.projectForm.rangeOfReturnedItems = getDecimal(rangeOfReturnedItems);
    },
    /* 超件退货价格限制 */
    returnPriceOfSuperPartsInput() {
      let returnPriceOfSuperParts = this.projectForm.returnPriceOfSuperParts;
      this.projectForm.returnPriceOfSuperParts = getDecimal(
        returnPriceOfSuperParts
      );
    },
    /* 大宗出库价格限制 */
    bulkDeliveryPriceInput() {
      let bulkDeliveryPrice = this.projectForm.bulkDeliveryPrice;
      this.projectForm.bulkDeliveryPrice = getDecimal(bulkDeliveryPrice);
    },
    /* 卸货价格限制 */
    unloadingPriceInput() {
      let unloadingPrice = this.projectForm.unloadingPrice;
      this.projectForm.unloadingPrice = getDecimal(unloadingPrice);
    },
    /* 市配单价限制2位小数点 */
    cityMatchingPriceInput() {
      let cityMatchingPrice = this.projectForm.cityMatchingPrice;
      this.projectForm.cityMatchingPrice = getDecimal(cityMatchingPrice);
    },
    /* 面单费用限制2位小数点 */
    faceFeeInput() {
      let faceFee = this.projectForm.faceFee;
      this.projectForm.faceFee = getDecimal(faceFee);
    },
    /* 服务单价 */
    unitPriceInput(index) {
      let unitPrice = this.projectForm.domains[index].unitPrice;
      this.projectForm.domains[index].unitPrice = getDecimal(unitPrice);
    },
    copyText() {
      let oInput = document.createElement('input');
      oInput.value = this.tokenText;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("copy")
      this.$message.success('已复制')
      oInput.remove()
    },
    /* 添加服务 */
    addDomain() {
      this.projectForm.domains.push({
        serviceType: null,
        serviceName: '',
        unitPrice: null
      });
    },
    removeDomain(item) {
      let index = this.projectForm.domains.indexOf(item)
      if (index !== -1) {
        this.projectForm.domains.splice(index, 1)
      }
    },
    changeServiceName(index) {
      let domainsObj = this.projectForm.domains[index]
      let obj = this.serviceNameList.find(i => { return i.id == domainsObj.serviceType})
      this.projectForm.domains[index].serviceName = obj.serviceName
    }
  },
};
</script>

<style lang='scss'>
.addProject {
  .base-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    line-height: 52px;
    border-bottom: 1px solid #eee;
    padding-left: 30px;
    padding-right: 30px;
    .token {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .copy {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .w294 {
    width: 294px;
  }
  .w230 {
    width: 230px;
  }
  .w230.is-disabled .el-input__inner {
    background: rgba(238, 238, 238, 0.3);
  }
  .el-input.w230 .el-input__inner {
    border-radius: 4px 0px 0px 4px;
    border-right: none;
  }
  .el-range-editor.is-disabled,
  .el-range-editor.is-disabled input {
    background: #fff;
  }
  .w64 {
    width: 64px;
  }
  .el-select.w64 .el-input__inner {
    background: #eeeeee;
    border-radius: 0px 4px 4px 0px;
  }
  .projectForm {
    .row {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 20px;
      .label2 {
        height: 52px;
        line-height: 52px;
        border-bottom: 1px solid #eee;
        padding-left: 30px;
      }
      .row-item {
        padding: 20px 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .el-form-item {
          width: 33.33%;
          .el-form-item__label {
            float: none;
          }
          .el-form-item__content {
            margin-left: 0px !important;
          }
          .el-input.white .el-input__suffix {
            top: 0px;
            right: 10px;
          }
        }
        .cut-time {
          .el-input.white .el-input__suffix {
            top: -2px;
          }
        }
      }
      .borderTop {
        padding: 0px 30px 20px 30px;
        .row-item {
          padding: 20px 0px 0px 0px;
          border-top: 1px solid #eee;
        }
        .increment-service {
          border-top: 1px solid #eee;
          &-title {
            margin-top: 28px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
          }
          .row-item {
            border-top: none;
            position: relative;
            &::before {
              content: '';
              position: absolute;
              width: 1px;
              height: 100px;
              background: #E0E8FC;
              top: -24px;
              left: 8px;
            }
          }
          .remove-domain {
            margin-left: 20px;
          }
          .service-name {
            .el-form-item__label {
              padding-left: 26px;
            }
          }
          .sort {
            display: inline-block;
            width: 16px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            background: #2E68EA;
            border-radius: 2px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            margin-right: 10px;
          }
        }
        
        .increment-service :nth-child(2){
          &::before {
            content: '';
            display: none;
          }
        }
      }
      .rental-costs-row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20px 30px;
        .el-form-item__label {
          float: none;
        }
        .el-form-item__content {
          margin-left: 0px !important;
        }
        .add-section {
          cursor: pointer;
          margin-top: 44px;
          color: #2E68EA;
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
        }
      }
      .footer {
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .section-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 30px 20px 30px;
    .sub-title {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 10px;
    }
    .btn-text {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      font-weight: 400;
      color: #2E68EA;
      margin-left: 19px;
      cursor: pointer;
    }
    .section {
      margin-right: 40px;
      .interval {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .blank {
          padding: 0 10px;
        }
        .el-input {
          width: 100px;
        }
      }
    }
  }
}
</style>
<style>
 .el-select-dropdown.is-multiple .el-select-dropdown__item.removeOption::after {
  content: ''
}
 .el-select-dropdown.is-multiple .el-select-dropdown__item.removeOption {
  display: flex;
  justify-content: space-between;
}
</style>
